module.exports = __webpack_public_path__ + "img/0499e6_60f77b108b054e3a860a07656d661cbc_mv2.2d040eba.webp";